
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#006cac","d":"M16 1.28C7.87 1.28 1.28 7.87 1.28 16S7.87 30.72 16 30.72 30.72 24.13 30.72 16 24.13 1.28 16 1.28zm9.274 19.642v.006c0 .813-.659 1.472-1.472 1.472h-6.849c-.942 1.904-2.87 3.189-5.099 3.189a5.67 5.67 0 112.998-10.484 14.378 14.378 0 01-.549-1.345 5.22 5.22 0 01-.222-2.134 8.8 8.8 0 01-.037-.844c0-.441.027-.877.078-1.304.462-1.753 1.646-2.246 3.061-2.246s2.56.493 3.053 2.298a9.3 9.3 0 01.036 2.157c.015.107.021.278.021.449 0 .565-.072 1.114-.207 1.637a10.355 10.355 0 01-1.413 2.763c2.165.36 3.605 1.557 4.584 2.049 1.99.947 2.016 2.003 2.016 2.003zm-8.634-2.663c0-.077-.045-.154-.07-.23a5.08 5.08 0 00-.409-.808l.012.021a5.188 5.188 0 00-.548-.721 5.043 5.043 0 10.63 5.885c.152-.291.278-.603.375-.928.048-.159.093-.274.118-.396s.051-.23.077-.352a4.638 4.638 0 00-.005-1.854 4.779 4.779 0 00-.191-.65zm-1.248 2.381H12.64v2.758h-1.485V20.64H8.397v-1.485h2.758v-2.758h1.485v2.758h2.758z"}})])
          )
        }
      }
    